import React from 'react';
import { parsePhoneNumber } from 'libphonenumber-js';
import { Link } from '../../elements';
import { jsx as ___EmotionJSX } from "@emotion/react";
export default function PhoneNumber(props) {
  let phoneNumber;
  try {
    phoneNumber = parsePhoneNumber(props.number, props.country);
  } catch (e) {
    console.log(`${props.number} is not a valid number`);
  }
  if (!phoneNumber) {
    return ___EmotionJSX(React.Fragment, null, props.number);
  }
  if (props.callable) {
    return ___EmotionJSX(Link, {
      to: phoneNumber.getURI(),
      external: true,
      title: "Telefon"
    }, phoneNumber.formatInternational());
  } else {
    return ___EmotionJSX(React.Fragment, null, phoneNumber.formatInternational());
  }
}
PhoneNumber.defaultProps = {
  country: 'DE',
  callable: true,
  title: 'Telefon'
};